import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useTramiteStatus } from '@/common/hooks/useTramiteStatus';
import type { TramiteStatusProps } from './types';
import clsx from 'clsx';
import { useTramiteStatusSummary } from '../TramiteStatusSummary/useTramiteStatusSummary';

interface TramiteStatusCellProps extends TramiteStatusProps {
  showTooltip?: boolean;
}

const TramiteStatusCell: React.FC<TramiteStatusCellProps> = ({
  tramite,
  showTooltip = true,
  onClick,
  clickable = false,
  showProgress = true
}) => {
  const {
    completed,
    totalEnabled,
  } = useTramiteStatusSummary(tramite);
  const { config, displayText } = useTramiteStatus(tramite);

  const badgeClasses = clsx(
    config.className,
    clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''
  );

  const handleClick = () => {
    if (clickable && onClick) {
      onClick(tramite);
    }
  };

  const badge = (
    <Badge
      variant={config.variant}
      className={badgeClasses}
      onClick={handleClick}
    >
      {displayText}
      {showProgress && (
        <span className="ml-2 text-xs font-mono">
          ({completed}/{totalEnabled})
        </span>
      )}
    </Badge>
  );

  if (!showTooltip || !config.description) {
    return badge;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {badge}
      </TooltipTrigger>
      <TooltipContent>
        <p>{config.description}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default TramiteStatusCell;